import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import * as styles from "./styles";
export var SkipLinks = function SkipLinks(_ref) {
  var links = _ref.links;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.skipLinksWrapper
  }, links.map(function (_ref2) {
    var content = _ref2.content,
      sectionId = _ref2.sectionId;
    return /*#__PURE__*/React.createElement(_StyledA, {
      href: "#".concat(sectionId),
      key: sectionId,
      $_css2: styles.skipLink
    }, content);
  }));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = /*#__PURE__*/_styled2("a").withConfig({
  displayName: "SkipLinks___StyledA",
  componentId: "sc-1wneci5-0"
})(["", ""], function (p) {
  return p.$_css2;
});